import teacher3 from './teacher3';

const byId = {
  '3': teacher3,
};

export function getTeacherLanding(teacherId) {
  if (teacherId == null) return null;
  return byId[String(teacherId)] || null;
}
